"use client"
/* */
const sleep = (ms) => new Promise((res) => setTimeout(res, ms));

export { sleep };
//# sourceMappingURL=sleep.mjs.map
